import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SectionConfigModel } from '../../models/section-configuration.model';

@Component({
    selector: 'data-filtering-configuration',
    templateUrl: 'data-filtering-configuration.component.html',
    styleUrls: ['data-filtering-configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DataFilteringConfigurationComponent implements OnInit {
  @Input() sectionConfig: SectionConfigModel;
  @Input() parentFormGroup: FormGroup;

  expanded: boolean = false;
  form: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  private addControls(): void {
    this.form = this.fb.group({
      'excludeSections': this.fb.array(this.sectionConfig.filter.excludeSections ?? [])
    });
    this.parentFormGroup.addControl('filter', this.form);
  }
}